import classnames from 'classnames';
import React, { useState } from 'react';
import { invokeEvent } from 'shared-base';
import { useCustomEvent } from '../../hooks/useCustomEvent';
import { Wrapper } from './DropArea.style';

export type DropAreaProps = {};

export function DropArea(_props: DropAreaProps) {
  const [show, setShow] = useState(false);
  const [dragType, setDragType] = useState('');

  function allowDrop(ev: React.DragEvent) {
    ev.preventDefault();
  }

  async function onDrop(ev: React.DragEvent) {
    ev.preventDefault();

    const itemId = ev.dataTransfer.getData('text/plain');
    const eventName = dragType === 'model' ? 'modelDropped' : 'materialDropped';
    invokeEvent(eventName, { itemId });
  }

  useCustomEvent('dragStart', (data: any) => {
    setShow(true);
    setDragType(data.type);
  });

  useCustomEvent('dragEnd', () => {
    setShow(false);
    setDragType('');
  });

  const className = classnames('DropArea-wrapper', {
    show,
  });

  return (
    <Wrapper
      className={className}
      data-testid='DropArea-wrapper'
      onDragOver={allowDrop}
      onDrop={onDrop}
    ></Wrapper>
  );
}

export default DropArea;
